import type {TimestampField} from '@prismicio/client'
import dayjs from 'dayjs'
import type {ParsedUrlQuery} from 'src/common/types'

// Constants
export const POSTS_PER_PAGE = 6
export const BASE_URL = process.env.NEXT_PUBLIC_APP_URL || 'https://www.getmoss.com'

const ROUTE_PARAMS = ['uid', 'subpageUid']

/**
 * Generates SEO-friendly pagination URLs
 * Removes page param for page 1 to keep URLs clean
 */
export const generatePaginationUrl = (asPath: string, query: Record<string, ParsedUrlQuery>, page: number): string => {
  const pathname = asPath.split('?')[0].split('#')[0]

  const params = new URLSearchParams()

  Object.entries(query).forEach(([key, value]) => {
    if (key !== 'page' && !ROUTE_PARAMS.includes(key) && value) {
      params.set(key, String(value))
    }
  })

  if (page > 1) {
    params.set('page', String(page))
  }

  const queryString = params.toString()
  return `${BASE_URL}${pathname}${queryString ? `?${queryString}` : ''}`
}

export const calculatePagination = (totalItems: number, currentPage: number, itemsPerPage: number = POSTS_PER_PAGE) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage)
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = startIndex + itemsPerPage

  return {
    totalPages,
    startIndex,
    endIndex,
  }
}

export const getActiveCategoryIndex = (categoryParam: ParsedUrlQuery, categories: Array<{value: string}>): number => {
  if (!categoryParam || typeof categoryParam !== 'string') {
    return 0
  }

  const index = categories.findIndex((cat) => cat.value === categoryParam.toLowerCase())
  return index > 0 ? index : 0
}

export const buildPaginationQuery = (
  currentQuery: Record<string, ParsedUrlQuery>,
  pageNumber: number,
): Record<string, ParsedUrlQuery> => {
  const queryParams: Record<string, ParsedUrlQuery> = {...currentQuery}

  if (pageNumber > 1) {
    queryParams.page = String(pageNumber)
  } else {
    delete queryParams.page
  }

  return queryParams
}

export const formatDate = (date: TimestampField) => {
  if (!date) {
    return ''
  }

  return dayjs(date).format('MMMM D, YYYY')
}
